import { createElement } from "react";
import { Trans } from "react-i18next";
import { InputFieldDeleteDialogProps } from "./InputFieldDeleteDialog.tsx";
import { deleteHttp } from "../../../common/api/apiShared.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useInputFieldDeleteDialog(props: InputFieldDeleteDialogProps) {
    const snackBar = useDotLegalSnackbar();

    const deleteMutation = useDotLegalMutation(deleteInputFieldApi);
    const onDelete = () => {
        deleteMutation.mutate(props.inputFieldToDelete.id, {
            onSuccess: (resp: any) => {
                const deleteResponse = resp.value();
                if (deleteResponse.isDeleted) {
                    snackBar.show(createElement(Trans, { i18nKey: "itemDeletedSuccess", values: { name: props.inputFieldToDelete.name } }));
                    props.onDeleted();
                } else {
                    snackBar.show(createElement(Trans, { i18nKey: "cantDeleteInputField", values: { name: props.inputFieldToDelete.name } }), "warning");
                    props.onCloseDialog();
                }
            },
        });
    };

    async function deleteInputFieldApi(id: string) {
        return await deleteHttp(`/settings/input-fields/${id}`);
    }

    return {
        inProgress: deleteMutation.isLoading,
        onDelete,
    };
}
